import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC2TPuhE9kOomDOoWIaiACF391g4kb-yTM",
  authDomain: "onfleek-reunion.firebaseapp.com",
  projectId: "onfleek-reunion",
  storageBucket: "onfleek-reunion.appspot.com",
  messagingSenderId: "13682487429",
  appId: "1:13682487429:web:67e8ecdbe501ac582939ec",
  measurementId: "G-Y27V5N872Y",
};
app.initializeApp(firebaseConfig);

// Initialize Firebase
export const App = app;
